import React, {Fragment, useMemo} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Alert, Card} from "antd";
import {GUTTER_MD} from "../../../../../../styles/constants";
import {isJson} from "../../utils";

const mapStateToProps = ({
                             scenes: {mappingHandler: {mappingSet: {wizard, index}}}
                         }) => ({
    validateStatus: wizard.validateMappingStatus,
});

const JSONMessages = ({validateStatus}) => {
    return (
        <ul>
            {validateStatus.messages.map((msg, idx) => {
                if (isJson(msg)) {
                    const jsonMessages = JSON.parse(msg);
                    if (jsonMessages.messages) {
                        return jsonMessages.messages.map((childMsg, childIdx) => <li
                            key={`${idx}+${childIdx}`}>{childMsg}</li>);
                    }
                    if (jsonMessages.errorMessages) {
                        return jsonMessages.errorMessages.map((childMsg, childIdx) => <li
                            key={`${idx}+${childIdx}`}>{childMsg}</li>);
                    }
                    if (jsonMessages.errorMessage) {
                        if (Array.isArray(jsonMessages.errorMessage)) {
                            return jsonMessages.errorMessage.map((childMsg, childIdx) => <li
                                key={`${idx}+${childIdx}`}>{childMsg}</li>);
                        }
                        return (<li key={idx}>{jsonMessages.errorMessage}</li>);
                    }
                }
                return (<li key={idx}>{msg}</li>)
            })}
        </ul>
    )
}

const MappingSetValidateMapping = ({t, validateStatus, validateStatusFromProp}) => {
    const validateData = useMemo(() => validateStatus || validateStatusFromProp, [validateStatus, validateStatusFromProp]);
    if (!validateData) return null
    if (validateData.status === "success") {
        return (
            <Fragment>
                <Alert type="success"
                       message={t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.noErrors")}
                       showIcon/>
                <Card>
                    <ul>{(validateData.messages || []).map((msg, idx) => <li key={idx}>{msg}</li>)}</ul>
                </Card>
            </Fragment>
        )
    }

    if (!validateData.messages) {
        return (
            <Alert
                style={{marginBottom: GUTTER_MD}}
                message={t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.unknownErrorFound")}
                type="warning"
                showIcon
            />
        )
    }

    return <Fragment>
        <Alert
            style={{marginBottom: GUTTER_MD}}
            message={t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.someErrorsFound")}
            type="warning"
            showIcon
        />
        <Card bodyStyle={{overflow: "auto", maxHeight: "75vh"}}>
            <JSONMessages validateStatus={validateData}/>
        </Card>
    </Fragment>
}

export default compose(
    translate(),
    connect(mapStateToProps),
)(MappingSetValidateMapping);